import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import WarningIcon from "src/assets/svg-icons/auditing/warning.svg";
import SuccessIcon from "src/assets/svg-icons/auditing/success.svg";
import ErrorIcon from "src/assets/svg-icons/auditing/error.svg";

interface IProps {
  variant?: "info" | "success" | "warning" | "error" | "neutral";
  label?: string;
}

const SecondaryChip = ({ variant = "info", label }: IProps) => {
  const { t } = useTranslation("auditing");

  const variantConfig = {
    info: {
      color: "#4D4DEC",
      backgroundColor: "#F2F2FD",
      border: "#9999F4",
      label: t("new"),
      icon: (
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            bgcolor: "#4D4DEC",
          }}
        />
      ),
    },
    success: {
      color: "#17B26A",
      backgroundColor: "#ECFDF3",
      border: "#A9EFC5",
      label: t("confirmed"),
      icon: <img src={SuccessIcon} alt="" />,
    },
    warning: {
      color: "#FDB022",
      backgroundColor: "#FFFAEB",
      border: "#FEDF89",
      label: t("progress"),
      icon: <img src={WarningIcon} alt="" />,
    },
    error: {
      color: "#B32318",
      backgroundColor: "#FEF3F2",
      border: "#FDA29B",
      label: t("issue"),
      icon: <img src={ErrorIcon} alt="" />,
    },
    neutral: {
      color: "#344054",
      backgroundColor: "#F2F4F7",
      border: "#D0D5DD",
      label: t("neutral"),
      icon: (
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            bgcolor: "#667085",
          }}
        />
      ),
    },
  }[variant];

  return (
    <Chip
      sx={{
        color: variantConfig.color,
        backgroundColor: variantConfig.backgroundColor,
        border: `1px solid ${variantConfig.border}`,
        padding: "4px 10px",
        "& .MuiChip-label": {
          fontSize: "14px",
          fontWeight: 500,
        },
      }}
      label={label || variantConfig.label}
      icon={variantConfig.icon}
    />
  );
};

export default SecondaryChip;
